import {SyntheticEvent} from 'react';

import type {FilterGroupType} from '../components/MoreFilters/MoreFilters';
import {Refinement} from '../components/FilterGroup/FilterGroup';

import {
    INSTANT_BOOK_FILTER_ID,
    INSTANT_BOOK_FILTER_LABEL,
    FREE_CANCEL_60_DAYS_ID,
    FREE_CANCEL_30_DAYS_ID,
    FREE_CANCEL_14_DAYS_ID,
    LEGACY_INSTANT_BOOK_ID,
    INSTANT_BOOK_SLOT_VALUE,
    FREE_CANCELLATION_GROUP_ID,
} from '../constants/filters';

export const newArrayFromFilters = (values): string[] => {
    const newArray = (values.filter && [].concat(values.filter)) || [];
    newArray.sort();
    return newArray;
};

/* TODO: these need to be changed to the new canonical integer refinement references when those are available */
const excludedFilters = [
    'bedrooms_title',
    'bedrooms_min_title',
    'bathrooms_title',
    'sleeps_title',
    // exclude A/B test filters
    FREE_CANCELLATION_GROUP_ID,
];

export const displayFilterGroup = ({
    filters = [],
    groupInfo: {id},
}: FilterGroupType): boolean => {
    return !(
        id &&
        (!filters ||
            filters.length <= 0 ||
            excludedFilters.includes(id.toLowerCase()))
    );
};

export const instantBookFilter = (filter: any): string | null => {
    const filtered = []
        .concat(filter || [])
        .map((f: string) => f.toLowerCase().trim())
        .filter(
            (f) =>
                INSTANT_BOOK_FILTER_ID === f ||
                LEGACY_INSTANT_BOOK_ID === f ||
                f.includes(INSTANT_BOOK_SLOT_VALUE)
        );
    return filtered.length ? filtered[0] : null;
};

const OLB_GROUP_IDS = ['online_booking_title', 'booking_title'];

/**
 * Returns filter group filters (Refinements), with filtered out Instant Booking filter from OLB filter group
 *
 * @param {FilterGroupType} filterGroup
 * @returns {Refinement[]}
 */
export const filterGroupFilters = ({
    filters = [],
    groupInfo: {id},
}: FilterGroupType) => {
    if (!filters) {
        return [];
    }

    if (OLB_GROUP_IDS.includes(id.toLowerCase())) {
        return filters.reduce<any[]>((acc, searchFilter: {filter}) => {
            if (!instantBookFilter(searchFilter.filter.refineByQueryArgument)) {
                acc.push(searchFilter);
            }
            return acc;
        }, []);
    }

    return filters;
};

export const getCancellationFilterId = (filter: any): string | null => {
    const filtered = []
        .concat(filter || [])
        .map((f: string) => f.toLowerCase().trim())
        .filter(
            (f) =>
                FREE_CANCEL_60_DAYS_ID === f ||
                FREE_CANCEL_30_DAYS_ID === f ||
                FREE_CANCEL_14_DAYS_ID === f
        );
    return filtered.length ? filtered[0] : null;
};

export const isOnlyInstantConfirmationFilter = (filters: string[]) => {
    return filters.length === 1 && !!instantBookFilter(filters);
};

// eslint-disable-next-line complexity
export const getFilterId = (event: SyntheticEvent<HTMLInputElement>) => {
    const filterId =
        (event.currentTarget && event.currentTarget.getAttribute('name')) || '';
    const matches = filterId.match(/:(.+$)/);

    if (!matches) {
        return null;
    }

    if (
        filterId === INSTANT_BOOK_FILTER_ID ||
        filterId === LEGACY_INSTANT_BOOK_ID
    ) {
        return INSTANT_BOOK_FILTER_LABEL;
    }

    return matches[1];
};

export const isFilterSelected = (
    filters: string[],
    expectedFilter: string
): boolean => {
    if (filters) {
        return filters.includes(expectedFilter);
    }
    return false;
};

export const parseFilterName = (filterId: string) => {
    if (filterId) {
        return `filter:${filterId}`;
    }
    return null;
};

export const cannotFilter = (resultsCount: number | null): boolean => {
    return (
        typeof resultsCount === 'number' &&
        !!(Number.isInteger(resultsCount) && resultsCount === 0)
    );
};

export function getGroupFiltersSelected(
    groupFilters: Refinement[],
    selectedFilters: string[]
): Refinement[] {
    return groupFilters.filter(({filter}) => {
        return selectedFilters.includes(filter.refineByQueryArgument);
    });
}
export const getFreeCancellationFilters = (
    filterGroups: FilterGroupType[] = []
) => {
    const freeCancellationGroup = filterGroups.find(({groupInfo}) => {
        return groupInfo.id === FREE_CANCELLATION_GROUP_ID;
    });
    const filters = freeCancellationGroup && freeCancellationGroup.filters;
    return filters ? filters : [];
};
